import { forwardRef } from 'react';
import styled from 'styled-components';
import type { ContainerProps } from '../../lib/card';
import { CardLayout } from '../../lib/card';
import type { DefaultComponentProps } from '../../types';
import { useSocialFeedSettings } from '../../utils';

const _CardContainer = forwardRef<
  HTMLDivElement,
  DefaultComponentProps & ContainerProps
>(({ children, ...forwardingProps }, ref) => {
  const { postHeightNormalization } = useSocialFeedSettings();

  return (
    <CardLayout.Container
      {...forwardingProps}
      ref={ref}
      _heightNormalization={postHeightNormalization}
    >
      {children}
    </CardLayout.Container>
  );
});

export const CardContainer = styled(_CardContainer).withConfig({
  shouldForwardProp: () => true
})``;
